import React from "react";

import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";

import { InformationBubble } from "components/InformationBubble";

import { templateUpdateWarning } from "lib/sideLoadedFieldMapping";

interface TemplateEditWarningProps {
  templateName: string;
  otherDataSetCount: number;
}

export function TemplateEditWarning({
  templateName,
  otherDataSetCount,
}: TemplateEditWarningProps): React.JSX.Element {
  return (
    <InformationBubble
      icon={faExclamationCircle}
      fontSize="beta"
      message={templateUpdateWarning(templateName, otherDataSetCount)}
    />
  );
}
